<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-编辑活动-其它
      -->
  <div>
    <div class="common-form">其它</div>

    <el-form-item label="活动排序" :rules="[{ required: true, message: '请输入活动排序' }]" prop="sort">
      <div class="max-w460">
        <el-input v-model="form.sort" type="number"></el-input>
      </div>
    </el-form-item>
    <el-form-item label="是否启用">
      <el-radio-group v-model="form.status">
        <el-radio :label="0">未启用</el-radio>
        <el-radio :label="1">启用</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: ['form']
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/multigroup/active/part/Other.vue